import React from 'react';
import Button from '@mui/material/Button';

export const OnChainAction = Object.freeze({
  Mint: 0,
  List: 1,
  Update: 2,
  Delist: 3,
  Buy: 4,
  ListedBuyYou: 5,
  DraftMinted: 6,
  DraftGenerated: 7,
  DeleteDraft: 8,
});

const getButtonText = (action) => {
  switch (action) {
    case OnChainAction.Mint:
      return 'Mint';
    case OnChainAction.List:
      return 'List';
    case OnChainAction.Update:
      return 'Update';
    case OnChainAction.Delist:
      return 'Delist';
    case OnChainAction.Buy:
      return 'Buy Now';
    case OnChainAction.ListedBuyYou:
      return 'Listed By You';
    case OnChainAction.DraftMinted:
      return 'Minted';
    case OnChainAction.DraftGenerated:
      return 'Generated';
    case OnChainAction.DeleteDraft:
      return 'Delete';
  }
  return 'Unknown';
};

const OnChainButton = ({ onClick, action, tokenColor, glowColor, isEnabled }) => {
  return (
    <Button
      variant="contained"
      fullWidth
      sx={{
        borderRadius: 2,
        textTransform: 'none',
        fontWeight: 'bold',
        background: `linear-gradient(135deg, ${tokenColor}90 0%, ${tokenColor}60 100%)`,
        boxShadow: `0 0 15px ${glowColor}`,
        '&:hover': {
          background: `linear-gradient(135deg, ${tokenColor} 0%, ${tokenColor}90 100%)`,
          boxShadow: `0 0 20px ${glowColor}`,
        },
      }}
      onClick={onClick}
      disabled={!isEnabled}
    >
      {getButtonText(action)}
    </Button>
  );
};

export default OnChainButton;
